import React from 'react';
import { Container, ListGroup, ListGroupItem, Table } from 'reactstrap';
import SEO from 'shared/components/SEO';
import { companies } from '../config';

function Voorwaarden() {
  const {
    title,
    location: { street, number, postalCode, city, countryCode },
    openingHours,
    contact: {
      // phone,
      email,
    },
    banc,
    // vat,
    // social,
  } = companies.shopdeal;

  return (
    <Container className="py-3">
      <SEO
        title="algemene voorwaarden"
        description="Lees hier onze algemene voorwaarden"
        canonical="/algemene-voorwaarden"
      />
      <div>
        <h1 className="text-uppercase">Algemene voorwaarden</h1>
        <ListGroup flush>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">1. Identiteit van de onderneming</h2>
            <Table responsive borderless>
              <tbody>
                <tr>
                  <th>Naam ondernemer</th>
                  <td>Casymo bv</td>
                </tr>
                <tr>
                  <th>Handelend onder de naam</th>
                  <td>{title}</td>
                </tr>
                <tr>
                  <th>Kantooradres</th>
                  <td>
                    {street} {number}, {postalCode} {city}
                  </td>
                </tr>
                <tr>
                  <th>Telefoonnummer</th>
                  <td>
                    <a href="tel:+32 484 98 48 85">+32 484 98 48 85</a>
                  </td>
                </tr>
                <tr>
                  <th>E-mail adres</th>
                  <td>
                    <a href={`mailto:${email}`}>{email}</a>
                  </td>
                </tr>
                <tr>
                  <th>Bereikbaarheid</th>
                  <td>{openingHours}</td>
                </tr>
                <tr>
                  <th>IBAN nummer</th>
                  <td>{banc.account}</td>
                </tr>
                <tr>
                  <th>BIC/ SWIFT</th>
                  <td>{banc.BIC}</td>
                </tr>
                <tr>
                  <th>BANK</th>
                  <td>{banc.name}</td>
                </tr>
                {/* <tr>
                  <th>BTW nummer</th>
                  <td>{vat}</td>
                </tr> */}
              </tbody>
            </Table>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">2. Algemene Bepalingen</h2>
            <p>
              De consument heeft het recht aan SHOPDEAL mee te delen dat hij afziet van de aankoop,
              zonder betaling van een boete en zonder opgave van motief binnen 14 kalenderdagen
              vanaf de dag die volgt op de dag van de levering van het goed of op het sluiten van de
              dienstovereenkomst. Indien hiermee verzendkosten gepaard gaan; zowel verzend als
              retour zijn deze ten allen tijden ten laste van de klant. Wij danken je voor jouw
              bezoek aan de website toegankelijk op het adres www.shopdeal.be, hierna de “website”,
              eigendom van en beheerd door de vennootschap Casymo bvba, met maatschappelijke zetel
              te {street} {number}, {postalCode} {city}, {countryCode} met ondernemingsnummer BE0
              536.358.530, hierna casymo bvba. SHOPDEAL is actief in enkel en alleen one shot deals.
              Met andere woorden het verkopen van volledige loten met een stock. Wij verzenden
              binnen de 24 uur en leveren zo snel mogelijk op uw gewenst adres. Onderhevige
              voorwaarden zijn van toepassing op alle artikelen uit het assortiment en elke aankoop
              die de klant plaatst op de website. De klant aanvaardt dat deze voorwaarden als enige
              van toepassing zullen zijn, met uitsluiting van zijn eingen algemene of specifieke
              (aankoop) voorwaarden, ook als deze zouden bedingen dat zij als enige van toepassing
              zijn.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">3. Toepasselijkheid</h2>
            <p>
              De algemene voorwaarden zijn van toepassing op het volledige aanbod dat wordt
              aangeboden op de website. Vooraleer de overeenkomst tussen beide partijen wordt
              afgesloten zal de consument de algemene voorwaarden geprensenteerd krijgen en dient
              hij deze te aanvaarden. Indien voor welke reden dan ook, de algemene voorwaarden niet
              kan worden afgebeeld zal de consument de algemene voorwaarden per mail toegezonden
              krijgen zodanig dat deze door de consument op een eenvoudige manier kan worden
              opgeslagen op diens computer of kan worden afgedrukt.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">4. Aanbod</h2>
            <p>
              SHOPDEAL tracht steeds zo een volledige en nauwkeurige omschrijving te geven van de
              producten dat worden aangeboden. De omschrijving zal steeds zodanig gedetailleerd zijn
              zodat de consument een goede beoordeling kan maken van het aangeboden product. Verder
              zal SHOPDEAL waarheidsgetrouwe afbeelding voorzien van de aangeboden producten.
              Ondanks dat de catalogus en website met de grootst mogelijke zorgvuldigheid worden
              samengesteld, is het toch mogelijk dat de aangeboden informatie onvolledig is, of
              materiële fouten bevat, of niet up-to-date is. Wanneer de consumente specifieke vragen
              zou hebben die niet geafficheerd zijn op de website verzoeken wij u vooraf contact op
              te nemen met onze klantendienst.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">5. De prijs</h2>
            <p>
              Prijzen die worden geafficheerd zijn steeds vast en zullen tijdens het moment van het
              aanbod niet wijzigen. Enkel indien er een wijziging van het btw-tarief wordt
              doorgevoerd kan dit een invloed hebben op de prijs. De prijs die wordt geafficheerd op
              de website zijn inclusief btw, accijnzen en overige taksen. Omdat onze producten
              verzonden worden door een externe transportfirma komen er steeds verzendkosten bij.
              Deze zullen duidelijk voor de aankoop getoond worden. De verzendkost kan varrieren
              afhankelijk van de waarde van de bestelling en de locatie naar waar deze dient te
              worden verzonden. SHOPDEAL zal op regelmatige basis promotionele acties afficheren op
              de website. Deze lopen zolang de promotionele periode is geafficheerd of tot einde
              stock. Alle informatie omtrent deze acties zullen zo duidelijk mogelijk worden
              gecommuniceerd op de website. Uitzonderlijk zou het kunnen dat er 2 of meerdere
              promoties tijdelijk naast elkaar lopen. Het is belangrijk te weten dat een gebruiker
              niet tegelijk aan beide acties kan deelnemen. Dit zal ook zo worden gecommuniceerd
              tijdens de promotie periode. SHOPDEAL behoud bovendien het recht een bestelling aan te
              passen indien er gemerkt wordt dat door een technische fout toch twee acties samen
              lopen op één of meerdere producten of productcategoriën.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">6. Betaling</h2>
            <p>
              Alle producten die via de website worden besteld dienen op voorhand te worden betaald.
              De aankoop is pas voldaan nadat de klant een bevestigingsmail krijgt van SHOPDEAL. De
              bestelde producten zullen worden toegezonden naar het aangeduide adres dat eveneens
              zichtbaar zal zijn op de bevestigingsmail. In het geval dat de betaling niet volledig
              wordt uitgevoerd en de goederen toch zijn verzonden, heeft SHOPDEAL het recht, na een
              periode van 30 dagen na factuurdatum, om extra kosten aan te rekenen wegens
              ingebrekestelling van volledige betaling. De interesten bedragen 10% per jaar op het
              openstaande factuurbedrag, net als een forfataire schadevergoeding van eveneens 10%
              van het openstaande factuurbedrag. Alle goederen die worden verstuurd blijven ten
              allen tijden eigendom van SHOPDEAL tot het moment dat de volledige betaling van de
              factuur is ontvangen. SHOPDEAL mag ook eisen de niet betaalde goederen terug te sturen
              en de hierdoor gemaakte kosten door te factureren naar de aankoper die oorspronkelijk
              de goederen heeft besteld maar niet volledig heeft betaald. Zolang er facturen
              openstaan mogen de door SHOPDEAL verzonden goederen niet doorverkocht, weggeschonken
              of roerend gemaakt worden. Indien er onjuistheden worden opgemerkt in de
              betalingsgegevens of er iets verdachts wordt opgemerkt tijdens de betaling, gelieve
              SHOPDEAL onmiddellijk te contacteren op het mailadres{' '}
              <a href={`mailto:${email}`}>{email}</a>.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">6. Conformiteit en garantie</h2>
            <p>
              De goederen die door SHOPDEAL worden verzonden zullen voldoen aan de normale
              verwachtignen die je mag hebben rekening houdende met de specificaties van het
              product. De goederen die door SHOPDEAL worden verzonden zullen ook voldoen aan alle
              wetten die op het moment van de bestelling van kracht zijn. In geval van schade of
              andere klachten omtrent het product, dient u binnen een periode van 24uur dit te
              melden aan SHOPDEAL via het e-mail adres <a href={`mailto:${email}`}>{email}</a>{' '}
              zodoende SHOPDEAL zijn rechten kan vrijwaren opzichtens de leveringsdienst. SHOPDEAL
              is geen fabrikant van de producten en verdeelt deze enkle via haar webshop. Dit wil
              zeggen dat SHOPDEAL geen enkele garantie kan geven omtrent de werking van de producten
              die zij te koop aanbiedt. Op de accesoires die worden aangeboden door SHOPDEAL is een
              garantie voorzien van 2 jaar.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">7. Herroepingsrecht</h2>
            <p>
              Alle goederen die zijn aangekocht bij SHOPDEAL mogen binnen een periode van 14 dagen
              teruggezonden worden zonder dat hier een reden voor wordt opgegeven. Belangrijk is dat
              de teruggezonden goederen in dezelfde staat terugkeren als oorspronkelijk verzonden.
              Dit wil zeggen dat de goederen niet beschadigd mogen zijn of niet deels geconsummeerd
              mogen zijn. De klant wordt verwacht de verpakkingsdoos op zo een manier te openen dat
              hij de goederen niet beschadigd. Vervolgens kan hij de goederen inspecteren en indien
              voor elke reden dan ook deze niet voldoet aan zijn verwachting kan hij deze binnen de
              periode van 14 dagen terug sturen. Belangrijk is dat de kosten die gepaard zijn bij de
              terugzending voor zijn rekening zijn. SHOPDEAL is niet verantwoordelijk voor de
              terugbetaling van gemaakte kosten voor de goederen terug te zenden. SHOPDEAL raad ook
              de klant aan een verzekering te nemen voor de goede terug zending van de goederen.
              Zodra de goederen in goede staat terug zijn toegekomen op ons adres ({street} {number}
              , {postalCode} {city}) zal SHOPDEAL binnen een periode van 30 dagen overgaan tot de
              terugbetaling van de goederen. Indien de goederen beschadigd, deels geconsummeerd of
              onvolledig bij ons worden teruggestuurd kan SHOPDEAL niet overgaan tot terugbetaling.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">8. Levering en uitvoering</h2>
            <p>
              Na betaling van de goederen zal SHOPDEAL trachten de aangekochte goederen binnen een
              periode van 48 uur te leveren op het aangeduide leveradres. Door externe
              omstandigheden kan deze periode langer duren. Dit is een middelenverbintenis en geen
              resultaatverbintenis. Alle goederen die worden besteld zullen binnen een periode van
              maximaal 30 dagen geleverd worden bij de klant tenzij anders op voorhand aangegeven.
              Indien deze leveringstermijn niet gehaald wordt (wegens out of stock of andere
              redenen), heeft de klant het recht om zijn bestelling te annuleren en zal SHOPDEAL
              overgaan tot de totale terugbetaling van de niet geleverde goederen. De verzending van
              alle bestelde goederen en waardebons zijn steeds op het risico van SHOPDEAL. Indien u
              bestelling verloren of beschadigd zou geraken tijdens het verzendingsproces is dit
              steeds op kosten van SHOPDEAL. Echter zoals hierboven aangegeven, bij terugsturen van
              de goederen naar SHOPDEAL, is de klant zelf verantwoordelijk voor de terugzending en
              mogelijke kosten die hier aan verbonden zijn.
            </p>
          </ListGroupItem>
          <ListGroupItem className="my-2">
            <h2 className="mb-3">9. Overmacht</h2>
            <p>
              In geval van overmacht is SHOPDEAL niet gehouden zijn verplichtingen na te komen. Tot
              overmacht behoren alle omstandigheden die ervoor zorgen dat SHOPDEAL buiten hun wil om
              hun verplichtingen niet kunnen nakomen. Hierdonder kunnen behoren stakingen,
              bedrijfsstoringen, brand, natuurrampen, energiestoringen, communicatie- of
              netwerkstoringen, fouten afkomstig van derde enz. Eveneens is de klant gevrijwaard van
              zijn verplichtingen indien hij/ zij getroffen worden door dergelijke voorvallen.
            </p>
          </ListGroupItem>

          <ListGroupItem className="my-2">
            <h2 className="mb-3">10. Intelectueel eigendom</h2>
            <p>
              Het is verboden om teksten, beelden, logo’s of andere communicatie dat vertrekt vanuit
              SHOPDEAL te kopieren of te delen met derde. Indien u toch gebruik wilt maken van door
              SHOPDEAL geleverde teksten of beelden hoeft u eerst contact op te nemen via e-mail op
              het adres <a href={`mailto:${email}`}>{email}</a>. U mag deze pas gebruiken naar
              schriftelijke toestemming. Indien u deze toch gebruikt, zonder toestemming, heeft
              SHOPDEAL het recht te vragen deze te verwijderen.
            </p>
          </ListGroupItem>
        </ListGroup>
      </div>
    </Container>
  );
}

export default Voorwaarden;
